import ConfigProvider from "antd/es/config-provider";
import notification from "antd/es/notification";
import AppWithForm from "./AppWithForm";
import AppWithFormVonage from "./AppWithFormVonage";
import AppPegadaian from "./AppPegadaian";
import AppPegadaianVonage from "./AppPegadaianVonage";
import App147 from "./App147";
import App147Vonage from "./App147Vonage";
import React from "react";
// import AppWithoutFormVonage from "./AppWithoutFormVonage";
export default function Wrapper() {
  const [lat, setLat] = React.useState(null);
  const [long, setLong] = React.useState(null);
  React.useEffect(() => {
    if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
      const geolocationAPI = navigator.geolocation;
      if (!geolocationAPI) {
        notification.error({
          message: "Geolocation API is not available in your browser.",
          placement: "bottomRight",
          duration: 5,
        });
      } else {
        geolocationAPI.getCurrentPosition(
          (position) => {
            const { coords } = position;
            setLat(coords.latitude);
            setLong(coords.longitude);
          },
          (error) => {
            notification.error({
              message: "Something went wrong getting your position.",
              placement: "bottomRight",
              duration: 5,
            });
          }
        );
      }
    }
  }, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: window.THEMES.primary,
          colorLink: window.THEMES.linkColor,
          colorLinkHover: window.THEMES.linkColor,
        },
      }}
    >
      {parseInt(process.env.REACT_APP_USE_LOCATION) === 1 ? (
        lat && long ? (
          process.env.REACT_APP_PLATFORM === "vonage" ? (
            parseInt(process.env.REACT_APP_SHOW_FORM) === 3 ? (
              <AppPegadaianVonage lat={lat} long={long} />
            ) : parseInt(process.env.REACT_APP_SHOW_FORM) === 2 ? (
              <App147Vonage lat={lat} long={long} />
            ) : (
              <AppWithFormVonage lat={lat} long={long} />
            )
          ) : parseInt(process.env.REACT_APP_SHOW_FORM) === 3 ? (
            <AppPegadaian lat={lat} long={long} />
          ) : parseInt(process.env.REACT_APP_SHOW_FORM) === 2 ? (
            <App147 lat={lat} long={long} />
          ) : (
            <AppWithForm lat={lat} long={long} />
          )
        ) : null
      ) : process.env.REACT_APP_PLATFORM === "vonage" ? (
        parseInt(process.env.REACT_APP_SHOW_FORM) === 3 ? (
          <AppPegadaianVonage lat={lat} long={long} />
        ) : parseInt(process.env.REACT_APP_SHOW_FORM) === 2 ? (
          <App147Vonage lat={lat} long={long} />
        ) : (
          <AppWithFormVonage lat={lat} long={long} />
        )
      ) : parseInt(process.env.REACT_APP_SHOW_FORM) === 3 ? (
        <AppPegadaian lat={lat} long={long} />
      ) : parseInt(process.env.REACT_APP_SHOW_FORM) === 2 ? (
        <App147 lat={lat} long={long} />
      ) : (
        <AppWithForm lat={lat} long={long} />
      )}
    </ConfigProvider>
  );
}
